// components/portal/EnrichProgressBar.tsx
//
// The Egyptian-blue slide that says "an enrichment is writing, watch this space". One shared
// component because it now has two hosts - the Source view's top edge and the brand detail
// panel - and the whole point of the signal is that it looks identical wherever data is about
// to land. Driven by the shared sourceEnrichInFlight counter that kernel.enrichBrand maintains,
// so the agent's /fill-finances lights it exactly like the panel's own "Enrichir" buttons.
import React from 'react';
import { useKernelStore } from '@/kernel/kernelStores';

const ENRICH_PROGRESS_STYLE: React.CSSProperties = {
  background:
    'linear-gradient(90deg, #0C2A82, #1034A6, #1E50C8, #3B6FE0, #8AAAEE, #C9D9F7, #8AAAEE, #3B6FE0, #1E50C8, #1034A6, #0C2A82)',
  backgroundSize: '200% 100%',
  animation: 'sourceEnrichSlide 1.1s linear infinite',
};

export const EnrichProgressBar = () => {
  const inFlight = useKernelStore((state) => (state.sourceEnrichInFlight ?? 0) > 0);
  // ... OR the agent is executing commands in the active session. A /fill-finances turn is
  // enrich -> minutes of WEB_SEARCH -> record, and the bar used to die after the first leg -
  // "the aura stops at data enriched" - leaving the longest stretch of real work looking like
  // nothing. runningScriptId is the command runner's own lifecycle marker, so the bar now lives
  // exactly as long as the agent is acting, same grammar as the campaign working-aura.
  const scriptRunning = useKernelStore((state) => {
    const sessionId = state.activeChatSessionId;
    if (!sessionId) return false;
    const entry = state.entityKernelState[`ChatSession:${sessionId}`]?.state as
      | { runtime?: { runningScriptId?: string | null } }
      | undefined;
    return Boolean(entry?.runtime?.runningScriptId);
  });
  if (!inFlight && !scriptRunning) return null;
  return (
    <div className="pointer-events-none absolute inset-x-0 top-0 z-20 h-[3px] overflow-hidden">
      <div className="h-full w-full" style={ENRICH_PROGRESS_STYLE} />
      <style>{`@keyframes sourceEnrichSlide { 0% { background-position: 0% 0; } 100% { background-position: -200% 0; } }`}</style>
    </div>
  );
};
